import { Game } from "../models/game";
import { Flight } from "../models/flight";
import { Airport } from "../models/airport";
import { FlightPosition } from "../models/flight_position";

export function transformGameData(apiResponse: any): Game {
  return {
    id: apiResponse.id,
    difficulty: apiResponse.difficulty,
    flights: apiResponse.flights.map(transformFlight),
    game_type: apiResponse.game_type,
    region: apiResponse.region,
    rounds: apiResponse.flights.length,
    numberOfGamesPlayedByUser: apiResponse.number_of_games,
  };
}

function transformFlight(apiFlight: any): Flight {
  return {
    id: apiFlight.id,
    aircraft_icon: new URL(apiFlight.aircraft_icon),
    aircraft_name: apiFlight.aircraft_name,
    destination_airport: transformAirport(apiFlight.destination_airport),
    flight_duration: apiFlight.flight_duration,
    flight_iata: apiFlight.flight_iata,
    origin_airport: transformAirport(apiFlight.origin_airport),
    position: transformPosition(apiFlight.position),
    airline: apiFlight.airline,
  };
}

function getFlagEmoji(countryCode: string) {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char: string) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function transformAirport(apiAirport: any): Airport {
  return {
    id: apiAirport.id,
    city: apiAirport.city,
    country_code: apiAirport.country_code,
    country_name: apiAirport.country_name,
    iata: apiAirport.iata,
    lat: parseFloat(apiAirport.lat),
    lon: parseFloat(apiAirport.lon),
    municipality: apiAirport.municipality,
    name: apiAirport.name,
    state_name: apiAirport.state_name,
    timezone: apiAirport.timezone,
    country_emoji: getFlagEmoji(apiAirport.country_code),
    daily_departures: apiAirport.daily_departures,
  };
}

function transformPosition(apiPosition: any): FlightPosition {
  return {
    altitude: apiPosition.altitude,
    direction: apiPosition.direction,
    lat: parseFloat(apiPosition.lat),
    lon: parseFloat(apiPosition.lon),
    speed: apiPosition.speed,
  };
}
